import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import AjustesMenu from '../components/AjustesMenu'; // O '../components/AjustesMenu' según la ruta real


function CambiarPin() {
  const [actual, setActual] = useState('');
  const [nuevo, setNuevo] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const perfilActual = JSON.parse(localStorage.getItem('perfilActual'));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (actual !== perfilActual.pin) return setError('El PIN actual no es correcto');
    if (nuevo !== confirmar) return setError('Los nuevos PIN no coinciden');
    if (nuevo.length < 4) return setError('El nuevo PIN debe tener al menos 4 cifras');

    try {
      await api.put(`/perfiles/${perfilActual.id}`, {
        nombre: perfilActual.nombre,
        avatar: perfilActual.avatar,
        telefono: perfilActual.telefono,
        telegram: perfilActual.telegram,
        email: perfilActual.email,
        pin: nuevo
      });
      perfilActual.pin = nuevo;
      localStorage.setItem('perfilActual', JSON.stringify(perfilActual));
      navigate(`/perfil/${perfilActual.id}`);
    } catch (err) {
      setError('Error al cambiar el PIN');
    }
  };

  const handleVolver = () => {
    navigate(-1);
  };

  return (
    <div style={styles.container}>
      <AjustesMenu />
      <button onClick={handleVolver} style={styles.volverMejorado}>Volver</button>
      <h2>Cambiar PIN</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="password"
          placeholder="PIN actual"
          value={actual}
          onChange={(e) => setActual(e.target.value)}
          maxLength={10}
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Nuevo PIN"
          value={nuevo}
          onChange={(e) => setNuevo(e.target.value)}
          maxLength={10}
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Confirmar nuevo PIN"
          value={confirmar}
          onChange={(e) => setConfirmar(e.target.value)}
          maxLength={10}
          style={styles.input}
        />
        {error && <p style={styles.error}>{error}</p>}
        <button type="submit" style={styles.button}>Cambiar PIN</button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    minHeight: '100vh'
  },
  volverMejorado: {
    position: 'absolute',
    top: '0.5rem',
    left: '0.5rem',
    background: '#444',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '0.3rem 0.5rem',
    fontSize: '1.3rem',
    cursor: 'pointer',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    width: 'fit-content'
  },
  form: {
    maxWidth: '400px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  input: {
    padding: '0.6rem',
    fontSize: '1.2rem',
    borderRadius: '8px',
    border: '1px solid #555',
    background: '#111',
    color: 'white',
    textAlign: 'center'
  },
  button: {
    padding: '0.8rem',
    background: '#444',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  error: {
    color: 'red'
  }
};

export default CambiarPin;
